import { graphql } from "relay-runtime"

export const PatientContextAppointmentFragment = graphql`
  fragment PatientContextAppointmentFragment on Appointment {
    id
    status
    isCompleted
    completedAt
    service
    appointmentType
    patientPhoneNumber
    startingSoonNotificationSent
    chatDetails {
      chatThreadId
    }
    channel
    language
    medgateConnectChannel
    partnerUserEmail
    requestType
    asyncRequestStatus
    ...RequestedMedicationsFragment
    billingAttribute {
      ...BillingAttributeFragment
    }
    fileUploadRequest {
      ...FileUploadRequestFragment
    }
    patientAddress {
      ...patientAddressTooltip_Address
      houseNumberStreet
      city
      postalCode
      countryCode
    }
    relatedPreventionPrograms {
      key
      patientId
      id
      preventionProgramId
      name {
        en
        de
        fr
        it
      }
      country
      analysis {
        matchedCase
        pointOfCare
        treatmentPlanTemplateId
      }
    }
  }
`
